import React from 'react'
import {PopularFacilities} from 'components/Accommodation/PopularFacilities'
import {WrapperWithPadding} from 'components/Accommodation/WrapperWithPadding'

import {Divider} from '@daedalus/atlas/Divider'
import {ContentHotel} from '@findhotel/sapi'

export const ConditionalFacilities = ({hotel}: {hotel: ContentHotel}) => {
  const shouldRenderFacilities = !hotel || hotel?.facilities

  if (!shouldRenderFacilities) return null

  return (
    <>
      <Divider sideMargin="s500" />
      <WrapperWithPadding>
        <PopularFacilities hotel={hotel} />
      </WrapperWithPadding>
    </>
  )
}
